import {
    VIDEO_OPEN_USER_VIDEO,
    VIDEO_WINDOW_OPEN,
    VIEW_USER_REQUEST,
    VIEW_USER_SUCCESS,
    VIEW_USER_STOP,
    VIEW_USER_RECONNECT,
    VIDEO_WINDOW_CLOSE,
    VIEW_LEAVE,
    STREAM_WATCHING_ME,
    STREAM_WATCHER_COUNT,
    STREAM_STREAM_UPDATE,
    STREAM_LIMIT_REACHED,
    STREAM_STATUS_STOPPED,
    STREAM_STATUS_STARTED,
    STREAM_STATUS_ERROR,
} from '../constants/streaming'

export function openUserVideo(ufrag) {
    return {
        type: VIDEO_OPEN_USER_VIDEO,
        ufrag
    }
}

export function openVideoWindow(ufrag) {
    return openUserVideo(ufrag);

    /*return {
        type: VIDEO_WINDOW_OPEN,
        ufrag
    }*/
}

export function openStream(stream_id, ufrag) {
    return {
        type: VIDEO_WINDOW_OPEN,
        stream_id,
        ufrag
    }
}

export function viewUserSuccess(stream_id, ufrag, stream) {
    return {
        type: VIEW_USER_SUCCESS,
        stream_id,
        ufrag,
        stream
    }
}

export function viewUserStop(stream_id, reason) {
    return {
        type: VIEW_USER_STOP,
        stream_id,
        reason
    }
}

export function viewUserReconnect(ufrag, stream) {
    return {
        type: VIEW_USER_RECONNECT,
        ufrag,
        stream
    }
}

export function viewLeave(ufrag) {
    return {
        type: VIEW_LEAVE,
        ufrag
    }
}

export function watchingMe(ufrag, watching) {
    return {
        type: STREAM_WATCHING_ME,
        ufrag,
        watching
    }
}

export function watcherCount(data) {
    return {
        type: STREAM_WATCHER_COUNT,
        roomid: data.roomid,
        data: data.watcher_count
    }
}

export function streamUpdate(data) {
    return {
        type: STREAM_STREAM_UPDATE,
        roomid: data.roomid,
        data: data.stream_update
    }
}

export function streamingStartSuccess(stream) {
    return {
        type: STREAM_STATUS_STARTED,
        stream
    }
}

export function streamingStartError(code, reason) {
    return {
        type: STREAM_STATUS_ERROR,
        code,
        reason
    }
}

export function streamLimitReached() {
    return {
        type: STREAM_LIMIT_REACHED
    }
}


// WEBPACK FOOTER //
// ./src/actions/streaming.js